import dayjs from "dayjs"
import BaseTableRow from "../../../components/layout/BaseTableRow"
import { ReportWithRelationsType } from "../types"
import { ReactComponent as EYE } from "../../../assets/EyeICON.svg"
import { ReactComponent as EDIT } from "../../../assets/EditICON.svg"
import { ReactComponent as DELETE } from "../../../assets/DeleteICON.svg"
import { ReactComponent as ARCHIVE } from "../../../assets/ArchiveICON.svg"
import { ReactComponent as UNARCHIVE } from "../../../assets/UnArchiveICON.svg"
import BaseButton from "../../../components/elements/BaseButton"
import { useNavigate } from "react-router-dom"

type ReportTableRowType = {
    report: ReportWithRelationsType
    onDelete: (id: string) => void
    onToggleArchive: (id: string) => void
}

export default function ReportTableRow(props: ReportTableRowType) {
    const navigate = useNavigate()


    return (
        <BaseTableRow onClick={() => navigate(`/berichte/${props.report._id}`)}>
            <td className="table-cell">
                <p className="line-clamp-1 text-center">{dayjs(props.report.date).format("DD.MM.YYYY")}</p>
            </td>
            <td className="table-cell">
                <p className="line-clamp-1 text-center min-w-[10rem]">
                    {typeof props.report.objectId === 'string' 
                        ? props.report.objectId 
                        : `${props.report.objectId.adress?.street} ${props.report.objectId.adress?.nr}, ${props.report.objectId.adress?.plz} ${props.report.objectId.adress?.city}`
                    }
                </p>
            </td>
            <td className="hidden lg:table-cell">
                <p className="line-clamp-1 text-center">
                    {props.report.information.length > 50 ? props.report.information.substring(0, 50) + "..." : props.report.information}
                </p>
            </td>
            <td className="hidden md:table-cell">
                <p className="line-clamp-1 text-center">{props.report.documents?.length || 0}</p>
            </td>
            <td className="hidden md:table-cell">
                <p className="line-clamp-1 text-center">{props.report.materials?.length || 0}</p>
            </td>
            <td className="hidden lg:table-cell">
                <p className="line-clamp-1 text-center">{dayjs(props.report.createdAt).format("DD.MM.YYYY HH:mm")}</p>
            </td>
        </BaseTableRow>
    )
}
